import { render, staticRenderFns } from "./isBinding.vue?vue&type=template&id=b9b7a940&"
import script from "./isBinding.vue?vue&type=script&lang=js&"
export * from "./isBinding.vue?vue&type=script&lang=js&"
import style0 from "./isBinding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports